import { Component, OnInit } from '@angular/core';
import { PopUpService } from '../PopUpService';
import { RecoverPasswordReq } from './recover-password-req';
import { EkpayUser } from '../../user/ekpay_user';
import { NGXLogger } from 'ngx-logger';
import { SharedService } from '../shared.service';
import { OTPResponse } from '../registeration/gen-otp-response';
import { DataStorageService } from '../data-storage.service';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.css']
})
export class RecoverPasswordComponent implements OnInit {

  constructor(private popService: PopUpService, 
    private logger: NGXLogger, private sharedService: SharedService,  
    private dataStorageService: DataStorageService,
    private translate: TranslateService) { }
  recoverPasswordreq: RecoverPasswordReq;
  ekpayUser: EkpayUser;
  otpRespone: OTPResponse;
  subscription: Subscription;
  lang: string;

  ngOnInit() {
    this.subscription = this.dataStorageService.langData$.subscribe((data) => {
      this.lang = data;
      if (this.lang == '' || this.lang == null) {
        this.lang = localStorage.getItem("lang");
      }
      this.logger.debug('data lang is ' + this.lang);
      this.translate.use(this.lang);
    })
    this.recoverPasswordreq = new RecoverPasswordReq();
    // this.ekpayUser = JSON.parse(sessionStorage.getItem("otp_response")) as EkpayUser;
  }

  closeRecoverPop() {
    this.popService.isChangePassword = false;
  }

  recoverPassword() {
    //this.recoverPasswordreq.id = JSON.parse(sessionStorage.getItem("otp_response_new")).mobile;
    this.recoverPasswordreq.id = "";
    this.logger.debug("calling recover password...." + JSON.stringify(this.recoverPasswordreq));
    this.sharedService.recoverPassword(this.recoverPasswordreq).subscribe(data => {
      this.logger.debug("recover password response...." + JSON.stringify(data.body));
      this.otpRespone = data.body as OTPResponse;
      if (this.otpRespone.status == 'success') {
        this.popService.isChangePassword = false;
        this.popService.isChangePasswordSucc = true;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/recover-password/recover-password.component.ts